import React from "react";
import Logo1 from './Icons/logo.png'
import { Link } from "react-router-dom";

const NavBottom = () => {
    return (
        <div className="nav-bottom__right">
                <ul className="menu-items">
                    <li className="menu-item">
                        <Link to="/" className="menu-link">
                        <i class="fa-solid fa-house"></i><span>Home</span>
                        </Link>
                        <span className="menu-item__bottom"></span>
                    </li>
                    <li className="menu-item">
                        <Link to='/aboutme' className="menu-link" >
                            <i class="fa-solid fa-user"></i>
                            <span>About me</span>
                        </Link>
                        <span className="menu-item__bottom"></span>
                    </li>
                    <li className="menu-item">
                        <Link to="/projects" className="menu-link" href="#">
                            <i class="fa-solid fa-briefcase"></i>
                            <span>Projects</span>
                        </Link>
                        <span className="menu-item__bottom"></span>
                    </li>
                    <li className="menu-item">
                        <Link to="/blog" className="menu-link">
                            <i class="fa-solid fa-blog"></i>
                            <span>Blog</span>
                        </Link>
                        <span className="menu-item__bottom"></span>
                    </li>
                    
                    <li className="menu-item">
                        <Link to="/contact" className="menu-link" href="#">
                            <i class="fa-solid fa-address-book"></i>
                            <span>Contact</span>
                        </Link>
                        <span className="menu-item__bottom"></span>
                    </li>
                </ul>
        </div>
    )
}

export default NavBottom